<template>
  <div class="reply-form">
    <TextArea
      ref="textarea"
      v-model="replyValue"
      :placeholder="`回复 ${replyData.user && replyData.user.nickname ||''}：`"
      @empty="getTextAreaEmptyStatus"
    />

    <div class="reply-form-operation">
      <div class="button-wrapper">
        <gkButton class="reply-btn" color="blue" size="big" label="回复" :disabled="replyBtnDisabled" :use-lock="true" @click="handleSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import gkButton from 'gkui/button'
import TextArea from '../../components/textarea/TextArea'

export default {
  name: 'reply-form',
  components: {
    gkButton,
    TextArea
  },
  props: {
    /**
     * 文章id
     */
    aid: VueTypes.oneOfType([Number, String]).def(''),
    replyData: VueTypes.object.def({}),
    show: VueTypes.bool.def(false)
  },
  data () {
    return {
      replyValue: '',
      replyBtnDisabled: true
    }
  },
  methods: {
    getTextAreaEmptyStatus (status) {
      this.replyBtnDisabled = status
    },
    select () {
      this.$nextTick(() => {
        this.$refs.textarea.focus()
      })
    },
    handleSubmit ({clear}) {
      const isHasContent = /[^\n\s]+/g.test(this.replyValue)

      if (!isHasContent) {
        this.$Message.toast({
          message: '请输入内容'
        })
        clear && clear()
        return
      }

      this.$emit('submit', {
        clear,
        value: this.replyValue,
        cb: () => {
          this.replyValue = ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_common';
.reply-form {
  position: relative;
  display: flex;
  align-items: flex-end;
  width: 100%;
  margin-top: 20px;
  
  & .reply-form-operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;

    & .button-wrapper {
      & [gk-button] {
        height: 36px;
        border-radius: 4px;
      }

      & .reply-btn {
        width: 63px;

        &[disabled] {
          background: #94BAFF;
        }
      }
    }
  }

  & .reply-error {
    position: absolute; left: 0; bottom: -14px;
    @include lineFont(12, 400);
    color: $orange;
  }

  & .button-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  & [gk-button] {
    margin-left: 20px;
  }
  & .reply-btn {
    width: 70px;
  }
}
</style>